import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ConversationSummary } from '../../../domain/models/conversation-summary.model';
import { QuickQuestion } from '../../../domain/models/quick-question.model';
import { UserProfile } from '../../../domain/models/user-profile.model';

@Component({
  selector: 'talk-to-your-data-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  @Input() conversationHistory: readonly ConversationSummary[] | null = [];
  @Input() savedConversations: readonly ConversationSummary[] | null = [];
  @Input() quickQuestions: readonly QuickQuestion[] | null = [];
  @Input() selectedConversationId: string | null = null;
  @Input() userProfile: UserProfile | null = null;
  @Output() conversationSelected = new EventEmitter<string>();
  @Output() readonly conversationSaved = new EventEmitter<string>();
  @Output() readonly conversationUnsaved = new EventEmitter<string>();
  @Output() readonly conversationRenamed = new EventEmitter<{ conversationId: string; title: string }>();
  @Output() readonly conversationDeleted = new EventEmitter<string>();
  @Output() readonly quickQuestionSelected = new EventEmitter<QuickQuestion>();
  @Output() readonly newChatSelected = new EventEmitter<void>();

  onConversationSelected(conversationId: string): void {
    this.conversationSelected.emit(conversationId);
  }

  onConversationSaved(conversationId: string): void {
    this.conversationSaved.emit(conversationId);
  }

  onConversationUnsaved(conversationId: string): void {
    this.conversationUnsaved.emit(conversationId);
  }

  onConversationRenamed(request: { conversationId: string; title: string }): void {
    this.conversationRenamed.emit(request);
  }

  onConversationDeleted(conversationId: string): void {
    this.conversationDeleted.emit(conversationId);
  }

  onQuickQuestionSelected(question: QuickQuestion): void {
    this.quickQuestionSelected.emit(question);
  }

  onNewChat(): void {
    this.newChatSelected.emit();
  }
}
